import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cx from 'classnames';

const propTypes = {
  cursorPos: PropTypes.object,
};

class Ripple extends PureComponent {
  constructor() {
    super();
    this.state = {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const cursorPos = nextProps.cursorPos;
    // Prevent component duplicates do ripple effect at the same time
    if (cursorPos.time !== this.props.cursorPos.time) {
      // If has animated, set state to "false" first
      if (this.state.animate) {
        this.setState({ animate: false }, () => {
          this.reppling(cursorPos);
        });
      } else {
        this.reppling(cursorPos);
      }
    }
  }

  reppling(cursorPos) {
    // Get the element
    const $ripple = this.ripple;
    const $button = $ripple.parentElement;
    const buttonPos = $button.getBoundingClientRect();
    const buttonWidth = $button.offsetWidth;
    const buttonHeight = $button.offsetHeight;
    // Make a square ripple
    const rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth);
    // Make ripple position to be center
    const centerize = rippleWidthShouldBe / 2;
    this.setState({
      animate: true,
      width: rippleWidthShouldBe,
      height: rippleWidthShouldBe,
      top: cursorPos.top - buttonPos.top - centerize,
      left: cursorPos.left - buttonPos.left - centerize,
    });
  }

  render() {
    const className = cx({
      ripple: true,
      'ripple--state-animate': this.state.animate,
    });
    return (
      <div
        className={className}
        ref={(c) => { this.ripple = c; }}
        style={{
          top: `${this.state.top}px`,
          left: `${this.state.left}px`,
          width: `${this.state.width}px`,
          height: `${this.state.height}px`,
        }}
      />
    );
  }
}

Ripple.propTypes = propTypes;

export default Ripple;
